import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
    Typography,
    IconButton,
    Button,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const FolderPermissionModal = ({
    open,
    onClose,
    folderId,
    permissionList,
    onDelete,
    userEmail
}) => {
    const sharedUsers = permissionList.filter(
        (p) =>
            p.resourceId === folderId &&
            p.resourceType === "Folder" &&
            p.userEmail !== userEmail
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Permission Management</DialogTitle>

            <DialogContent>
                {sharedUsers.length === 0 ? (
                    <Typography color="text.secondary">
                        No shared users found.
                    </Typography>
                ) : (
                    <Stack spacing={2}>
                        {sharedUsers.map((item) => (
                            <Stack
                                key={item.permissionId}
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                    p: 1.5,
                                    border: "1px solid #eef0f4",
                                    borderRadius: 1,
                                }}
                            >
                                <Stack>
                                    <Typography fontSize="14px" fontWeight={600}>
                                        {item.userEmail}
                                    </Typography>
                                    <Typography fontSize="12px" color="text.secondary">
                                        {item.permissionType}
                                    </Typography>
                                </Stack>

                                <IconButton
                                    color="error"
                                    onClick={() => onDelete(item)}
                                >
                                    <DeleteOutlineIcon />
                                </IconButton>
                            </Stack>
                        ))}
                    </Stack>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}
                    sx={{
                        textTransform: "none",
                        color: "#F15744",
                        fontSize: "14px",
                        lineHeight: "100%",
                        fontFamily: "Outfit, sans-serif",
                        borderRadius: "25px",
                        fontWeight: 500,
                        px: "20px",
                        py: "15px",
                    }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FolderPermissionModal;
